module.exports = __webpack_public_path__ + "045cca0d3b30581c98d76958488b0024.pdf";